import { render, staticRenderFns } from "./dataFilterComp.vue?vue&type=template&id=2952a2e4&"
import script from "./dataFilterComp.vue?vue&type=script&lang=js&"
export * from "./dataFilterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports